import { __awaiter } from "tslib";
import { ref } from 'vue';
import ApiManager from '@/managers/apimanagers';
/**
 * @summary API権限
 */
export const useApiRole = () => {
    const isLoading = ref(false);
    /**
     * @returns API権限データの取得
     */
    const getApiRoles = () => __awaiter(void 0, void 0, void 0, function* () {
        let res;
        try {
            isLoading.value = true;
            res = yield ApiManager.get(`/api-roles`);
        }
        finally {
            isLoading.value = false;
        }
        return res;
    });
    return { isLoading, getApiRoles };
};
